import React, { useState, useEffect } from "react";
import { Collapse, Typography } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { generateDynamicStyling, getNetAmount, isEmpty, numberToCurrency } from "../../../Utils/utils";
import {
  selectCurrencyCode,
  selectToatalAmount,
} from "../../../slices/PaymentSessionDetailsSlice";
import "../fontStyling.css";
import TranslateText from "../../resuableComponents/TranslateText";
import { selectSelectedIntrument } from "../../../slices/SavedInstrumentSlice";
import { selectActivePaymentMethod } from "../../../slices/PaymentButtonSlice";

export const PaymentSummaryMobileContainer = ({ children }) => {
  const { t } = useTranslation();
  const currencyCode = useSelector((state) => selectCurrencyCode(state));
  const amount = useSelector((state) => selectToatalAmount(state));
  const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents.showTotalPaymentSummaryField);
  const togglePaymentSummaryFieldOnMobile = useSelector((state) => state.additionalComponents.togglePaymentSummaryFieldOnMobile);
  const [activeKey, setActiveKey] = useState("paymentSummary")
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const selectedInstrument = useSelector((state) => selectSelectedIntrument(state));
  const paymentDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails.paymentDetails);
  const dccQuotation = useSelector(state => state.cardDetails.dccQuotation);
  const dccMoney = dccQuotation?.dccQuotationDetails?.dccMoney?.amount;
  const isDccQuotationSelected = useSelector((state) => state.cardDetails.isDccQuotationSelected);
  const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail)
  const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents.totalPaymentSummaryValue);
  const totalSurchargeAmount = useSelector(state => state.surcharges.totalSurchargeAmount);


  // useEffect(() => {
  //   setActiveKey((showTotalPaymentSummaryField || togglePaymentSummaryFieldOnMobile) ? "paymentSummary" : null);
  // }, [showTotalPaymentSummaryField, togglePaymentSummaryFieldOnMobile]);

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const getAmount = (isDcc) => getNetAmount({
    isDcc,
    activePaymentMethod,
    selectedInstrument, dccMoney, amount: paymentDetails?.money?.amount,
    showTotalPaymentSummaryField, totalPaymentSummaryValue, offerAmount: appliedOfferDetail?.finalAmount,
    surchargeAmount: totalSurchargeAmount

  });
  const getExtra = () => {
    return (
      <Typography
        className="semiBold12Heading dynamic-font-family"
        style={{ color: "var(--Neutral-Grey-1000)" }}
      >
        {
          !activeKey?.includes('paymentSummary') && <>
            <span className="currency-symbol">
              {currencyCode}{" "}
            </span>
            {numberToCurrency(getAmount(isDccQuotationSelected), currencyCode)}
          </>
        }
      </Typography>
    );
  };

  return (
    <Collapse
      expandIconPosition="end"
      accordion
      activeKey={activeKey}
      onChange={handleCollapseChange}
      items={[
        {
          key: "paymentSummary",
          label: (
            <Typography className="domestic-ps-mobile-header dynamic-font-family">
              <TranslateText label={"PAYMENT_SUMMARY"}>Payment Summary</TranslateText>
            </Typography>
          ),
          children: <div className="dynamic-font-family">{children}</div>,
          extra: !showTotalPaymentSummaryField && getExtra(),
        },
      ]}
    />
  );
};
